export enum LightTheme {
  Primary = "rgb(70,101,136)",
  PrimaryBold = "#475467",
  DarkPrimary = "rgb(21,51,89)",
  LightColor = "#F4F4F4",
  DarkColor = "#EAEAEA",
  Gray = "#C4C4C4",
  Error = "#A80000",
  ErrorText = "red",
  Success = "#107C10",
  TextNormal = "#323130",
  TextPrimary = "#CCCCCC",
  TextDisabled = "#A6A6A6",
  BackgroundBlackWhite = "#FFFFFF",
  Background = "#FFFFFF",
  Background2 = "#F8F8F8",
  Background3 = "#F8F8F8",
  Background4 = "#FFFFFF",
  BorderColor = "#EAEAEA",
  BorderColor2 = "#C4C4C4",
  BlueBg = "rgb(21,51,89)",
  Warning = "#FFC107",
}